<template>
    <b-container>
        <div style="margin-top: 200px" v-show="loading">
            <ring-loader></ring-loader>
            <h1>Cargando...</h1>
        </div>

        <b-row v-show="!loading">
            <b-col md="10" offset="1">
                <b-card class="my-5 shadow">
                    <h3>Ranking &#x1F3C6;</h3>
                    <hr>
                    <table class="table table-bordered table-striped">
                        <thead>
                        <tr>
                            <th>Posición</th>
                            <th>Aciertos</th>
                            <th>Usuario</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(position, index) in top" :key="index">
                            <td>{{index + 1}}°</td>
                            <td>{{position.total}}</td>
                            <td>{{position.name}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <hr>
                    <p class="mb-0 text-left">* Las posiciones se actualizan cada hora</p>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {http} from "../../misc/http";
    import {RingLoader} from 'vue-spinners-css';

    export default {
        name: "Ranking",
        components: {
            RingLoader,
        },
        data() {
            return {
                top: [],
                loading: true,
            }
        },
        mounted() {
            this.getRanking();
        },
        methods: {
            async getRanking() {
                this.loading = true;
                const response = await http.get('/trivia/ranking');
                this.top = response.data.top;
                this.loading = false;
            },
        }
    }
</script>

<style scoped>
    .list-group-item:hover {
        background: #673bb7;
        color: snow;
        font-weight: bold;
        cursor: pointer;
    }

    .btn-anime {
        border-color: #673bb7;
        color: #673bb7;
    }

    .btn-anime:hover {
        background: #673bb7 !important;
        border-color: #673bb7 !important;
        color: snow;
    }

    .chosen {
        background: #673bb7;
        color: snow;
        font-weight: bold;
    }

    table tbody {
        font-weight: bold;
    }
</style>